import { Component, OnInit, Input, Output, EventEmitter, ComponentFactoryResolver, ViewChild, Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Subscription } from 'rxjs';
import { ToolListComponent } from 'src/app/component/tools/tool-list/tool-list.component';
import { DynamicComponentDirective } from 'src/app/directive/dynamicComponent/dynamic-component.directive';
import { LoaderService } from 'src/app/service/shared/loader/loader.service';
@Component({
  selector: 'app-tool-settings-table',
  templateUrl: './tool-settings-table.component.html',
  styleUrls: ['./tool-settings-table.component.scss'],
})
export class ToolSettingsTableComponent implements OnInit {
  @Input() headers: any; // column headers for table
  @Input() rows: any; // row data to display in table
  @Input() totalItems: any;
  @Input() sortData: string; // data indicating column
  @Input() selected?: Array<any>;
  @Input() meta: any;
  @Input() source: string;
  @Output() action = new EventEmitter<any>();
  @Output() selectedChange: EventEmitter<Array<any>> = new EventEmitter<Array<any>>();
  @Output() selectedAdd = new EventEmitter<any>();
  @Output() selectedRemove = new EventEmitter<any>();
  @Output() selectedAll = new EventEmitter<any>();
  @Output() refreshSelectAll = new EventEmitter<any>();
  @Output() removeAll = new EventEmitter<any>();

  subscription: Subscription;
  deselectAll: Boolean;

  @ViewChild(DynamicComponentDirective) dynamicComponent: DynamicComponentDirective;

  sort: any = { name: '', direction: '' };
  sortDirection: any = { asc: 'desc', desc: 'asc' }; // used as a toggle to switch between asc and desc order
  defaultDirection: string = 'asc';

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private toolList: ToolListComponent,
    private loaderService: LoaderService,
    private renderer2: Renderer2,
    @Inject(DOCUMENT) private _document,


  ) { }

  ngOnInit(): void {
    const [field, direction] = this.sortData?.split(',') || ['', ''];

    this.sort.name = field;
    this.sort.direction = direction;
    this.toolList.refreshAll.subscribe(res => {
      if (!Object.keys(res).length || !res.data) {
        return;
      }
      if (res.data.length === this.totalItems) {
        if (!this.deselectAll) {
          this.selected = [...res.data.map(row => row.id)];
          this.selectedAll.emit(res.data);
          this.selectedChange.emit(this.selected);
        } else {
          this.selected = [];
          this.removeAll.emit(res.data);
          this.selectedChange.emit(this.selected);
        }
        if (res.data.length > 50) this.refreshSelectAll.emit(50);
        this.loaderService.hideLoader();
      }
    });
  }

  loadTooltip() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadTooltip();`;
    this.renderer2.appendChild(this._document.body, s);
  }

  onInventoryHover(row?: any): void {
    this.loadTooltip();
  }

  isInventoryWithinLast12Months(row: any): boolean {
    if (!row?.inventory?.length) {
      return false;
    }

    // Last inventory record will always be the newest.
    const record = row.inventory[row.inventory.length - 1]

    const inventoriedDate = new Date(record.toolInventory.inventoriedDate);
    const currentDate = new Date();

    const twelveMonthsAgo = new Date();
    twelveMonthsAgo.setFullYear(currentDate.getFullYear() - 1);

    return inventoriedDate >= twelveMonthsAgo && inventoriedDate <= currentDate;
  }

  getInventoryTooltip(row: any): string {
    if (!row?.inventory?.length) {
      return 'No inventory date available';
    }

    // Last inventory record will always be the newest.
    const record = row.inventory[row.inventory.length - 1]

    const inventoriedDate = new Date(record.toolInventory.inventoriedDate);
    const formattedDate = inventoriedDate.toLocaleDateString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });

    return `Last Inventoried Date: ${formattedDate}`;
  }


  triggerAction(action: string, payload) {
    if (action === 'sort') {
      if (this.sort.name === payload) {
        this.sort.direction = this.sortDirection[this.sort.direction] || this.defaultDirection;
      } else {
        this.sort.name = payload;
        this.sort.direction = this.defaultDirection;
      }
      payload = `${this.sort.name},${this.sort.direction}`;
    }
    const actionData = { action, payload, source: this.source };

    this.action.emit(actionData);
  }

  printRowData(property, row, defaultValue = ''): string {
    if (typeof property === 'function') {
      return property(row) ?? '';
    }

    const str = row[property] ? row[property] : defaultValue;
    return str ?? '';
  }

  handleSelectAll(event: any) {
    this.loaderService.displayLoader();
    if (event.target.checked) {
      this.deselectAll = false;
      this.refreshSelectAll.emit();
    } else {
      this.deselectAll = true;
      this.removeAll.emit();
      this.loaderService.hideLoader();
    }
  }

  handleCheckbox(event): void {
    if (!event.target.checked) {
      // remove value, if  unchecked
      this.selected.splice(this.selected.indexOf(+event.target.value), 1);
      this.selectedChange.emit(this.selected);
      this.selectedRemove.emit(+event.target.value);
      return;
    }

    // push new value onto list, if checked
    this.selected.push(+event.target.value);
    this.selectedChange.emit(this.selected);
    this.selectedAdd.emit(+event.target.value);
  }

  setSort(searchParams: string) {
    const [field, direction] = searchParams?.split(',') || ['', ''];
    this.sort.name = field;
    this.sort.direction = direction;
  }

  resetSort() {
    this.sort = { name: '', direction: '' };
    this.defaultDirection = 'asc';

    const actionData = { action: 'sort', payload: '', source: this.source };
    this.action.emit(actionData);
  }
}
